import { Title } from '@angular/platform-browser';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';

import { Subscription } from 'rxjs';
import moment from 'moment';
import { ConfirmationService } from 'primeng/api';

import { DatabaseService } from '@app/database/database.service';
import { IExamen } from '@app/database/models/IExamen.model';
import { ExamFormContainerService } from '@app/shared/views/exam-form-container/exam-form-container.service';
import { MessageAlertService } from '@app/shared/views/_messagesService/_messageAlertServices';
import { AsideService } from '@app/shared/components/aside/aside.service';
import { BackgroundSyncService } from '@app/helpers/backgroundSync.service';
import { IEspecialidades } from '../../../../database/models/IEspecialidades.model';

import { ExamsConfigService } from '../exams-config/exams-config.service';
import { Examen } from '../exams-config/Examen.config';
import { GroupGTemplateService } from './group-g-template.service';
import { environment } from '@env/environment';
import { ConnectionService, ConnectionState } from 'ng-connection-service';

@Component({
	selector: 'app-group-g-template',
	templateUrl: './group-g-template.component.html',
	styleUrls: ['./group-g-template.component.scss']
})
export class GroupGTemplateComponent implements OnInit {

	public currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
	@Input() examen: any;
	submitted = false;
	public examForm: FormGroup;
	fecha: any;
	seniority = 0;
	unidadTiempo = '';
	radio: any;
	maxDate = new Date();
	maxDateIngreso = new Date();
	minDate: any;
	invalidField = false;
	tiposDictamen: any[] = [];
	especialidades: IEspecialidades[];
	accionesTrabajador: any[] = [];
	neurologicas: any[] = [];
	reflejos: any[] = [];
	tiposCaracterizacionSemiologica: any[] = [];
	footer: any[] = [];
	statuses = [
		{ label: 'Normal', value: 'Normal' },
		{ label: 'Anormal', value: 'Anormal' },
	];
	asideObservable: Subscription;
	displayAgentes = false;
	attachedFiles: any = {
		data: [],
		invalid: false,
		isEmpty: true,
		attachedFilesValidQuantity: 0
	};
	configForm: Examen;
	enviandose = false;
	isOnline = true;
	displayModalFirma = false;
	medicoFirmaB64;
	medicoFirmaSigString;
	manipulacionCargaValues = [
		{ label: 'Menos de 10 Kg.', value: 'manipulacionCargaMenora10' },
		{ label: 'Entre 10 y 20 Kg.', value: 'manipulacionCargaEntre10y20' },
		{ label: 'Más de 20 Kg.', value: 'manipulacionCargaMayora20' }
	];
	curvasValues = [
		{ label: 'Normal', value: 'N' },
		{ label: 'Aumentada', value: 'A' },
		{ label: 'Disminuida', value: 'D' }
	];
	ejeLateralValues = [
		{ label: 'Normal', value: 'N' },
		{ label: 'Concavidad derecha', value: 'CD' },
		{ label: 'Concavidad Izquierda', value: 'CI' }
	];
	tableExploracionNeurologicaInvalid = true;
	tableExploracionReflejosInvalid = true;
	tableEvaluacionClinicaFinalInvalid = true;
	gradosValues = [
		{ label: 'Grado 0', descripcion: 'Ausencia de signos y síntomas', value: 'grado0' },
		{ label: 'Grado 1', descripcion: 'Dolor en reposo y/o existencia de sintomatología sugestiva', value: 'grado1' },
		{ label: 'Grado 2', descripcion: 'Grado 1 más contractura y/o dolor a la movilización', value: 'grado2' },
		{ label: 'Grado 3', descripcion: 'Grado 2 más dolor a la palpación y/o percusión', value: 'grado3' },
		{ label: 'Grado 4', descripcion: 'Grado 3 más limitación funcional evidente clínicamente', value: 'grado4' }
	];
	disabledGroup: boolean;
	disabledStyle = { opacity: '0.6' };

	constructor(private titleService: Title,
		private formBuilder: FormBuilder,
		private router: Router,
		private examFormService: ExamFormContainerService,
		private confirmationService: ConfirmationService,
		private messageAlertServices: MessageAlertService,
		private asideService: AsideService,
		private backgroundSyncService: BackgroundSyncService,
		private databaseService: DatabaseService,
		private examConfigService: ExamsConfigService,
		private groupGTemplateService: GroupGTemplateService,
		private connectionService: ConnectionService
	) {
	}

	get f(): any {
		return this.examForm.controls;
	}

	ngOnDestroy(): void {
		if (this.asideObservable) {
			this.asideObservable.unsubscribe();
		}
		this.titleService.setTitle('Provincia ART ML Offline');
		this.asideService.setInsideExamen(false);
	}

	ngOnInit(): void {
		this.titleService.setTitle('Provincia ART ML Offline');
		this.connectionService.monitor().subscribe((connected: ConnectionState) => {
			this.isOnline = connected.hasNetworkConnection;
		})
		this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
		this.calcularAntiguedad();
		this.getTiposDictamen();
		this.getEspecialidades();
		this.cargarFormulario();
		this.minDate = new Date(moment(this?.examen?.fechaAsignacion).format());
		this.asideObservable = this.asideService.openModalSubject$.subscribe(
			(data) => {
				this.goBack(data);
			}
		);
		this.asideService.setInsideExamen(true);
	}

	async getEspecialidades(): Promise<void> {
		const especialidadesListFromOffline = await this.databaseService.getAllEspecialidadesFromOfflineDB();
		this.especialidades = especialidadesListFromOffline;
	}

	goBack(ruta?) {
		if (this.examForm.dirty) {
			this.confirm(ruta);
		} else {
			this.returnToExams(ruta);
		}
	}

	confirm(ruta?) {
		this.confirmationService.confirm({
			header: `¿Está seguro que desea cancelar la carga del examen?`,
			message: `Si cancela el examen ahora perderá toda la información cargada hasta el momento`,
			key: 'goBackFormG',
			accept: () => {
				this.returnToExams(ruta);
			},
		});
	}

	async getTiposDictamen(): Promise<void> {
		const dataFromOffline = await this.databaseService.getAllTiposDictamenFromOfflineDB();
		this.tiposDictamen = dataFromOffline.filter(
			(x) => x.codigo === 'A' || x.codigo === 'I' || x.codigo === 'N'
		);
	}


	returnToExams(ruta?) {
		this.router.navigate([ruta ? ruta : 'examenes']);
	}

	capitalize(word: string) {
		if (!word) {
			return word;
		}
		return word[0].toUpperCase() + word.substr(1).toLowerCase();
	}

	/**
	 * función que recibe el trigger desde el componente attach-upload-file
	 * con el objeto actualizado de la lista de archivos y errores
	 * @param  {object} event
	 * @example:
	 *  {
		errors: {
		  isSizeValid: false
		  isTypeValid: false
		},
		data: [
		  {
			archivoBase64: todounstringpegado,
			nombreOriginal: "example.png",
			tipo: "png",
			size: 121354
		],
		invalid: false
	  }
	 */
	getAttachedFiles(event: any) {
		let data = event.filesData;
		let errors = event.errors;
		this.attachedFiles = event;
		if (errors.isSizeValid && errors.isTypeValid) {
			// asigno la data al objeto para enviar
			return false;
		}
	}

	calcularAntiguedad(): any {
		if (this.examen.fechaAltaEmpleado) {
			this.seniority = moment().diff(
				moment(this.examen.fechaAltaEmpleado),
				'years'
			);
			if (this.seniority > 1) {
				this.unidadTiempo = 'años';
			} else if (this.seniority < 1) {
				this.seniority = moment().diff(
					moment(this.examen.fechaAltaEmpleado),
					'months'
				);
				if (this.seniority > 1) {
					this.unidadTiempo = 'meses';
				} else {
					this.unidadTiempo = 'mes';
				}
			} else {
				this.unidadTiempo = 'año';
			}
		}
	}

	showModalFirma() {
		this.displayModalFirma = true;
	}

	closeModalFirma() {
		this.displayModalFirma = false;
	}

	recibirDatosFirma(datos: { firmaB64: string, firmaSigString: string }) {
		this.medicoFirmaB64 = datos.firmaB64;
		this.medicoFirmaSigString = datos.firmaSigString;
	}

	cargarFormulario() {
		let codigoTipoExamen = (this.examen.tipoEstudio.codigo !== undefined)
			? this.examen.tipoEstudio.tipoEstudioCod
			: this.examen.tipoEstudio;
		this.configForm = this.examConfigService.getConfig(codigoTipoExamen);
		this.examForm = this.configForm.examForm;
		this.examen.trabajador.apellidoNombre ? this.examForm.controls.apellidoNombre.setValue(this.examen.trabajador.apellidoNombre) : null;
		this.examen.trabajador.fechaNacimiento ? this.examForm.controls.fechaNacimiento.setValue(new Date(moment(this.examen.trabajador.fechaNacimiento).format())) : null;
		this.examen.puestoTrabajador ?
		this.examForm.controls.puestoTrabajador.setValue(this.examen.puestoTrabajador) : null;
		this.examen.antiguedadPuestoTrabajador ?
		this.examForm.controls.antiguedadPuestoTrabajador.setValue(this.standarizeDate(this.examen.antiguedadPuestoTrabajador)) : null;
		this.examen.fechaIngresoEmpresa ?
		this.examForm.controls.fechaIngresoEmpresa.setValue(new Date(moment(this.examen.fechaIngresoEmpresa).format())) : null;
		this.restrictDateIngresoEmpresa();
		this.medicoFirmaB64 = this.examen.medicoFirmaB64;
    	this.medicoFirmaSigString = this.examen.medicoFirmaSigString;
		this.calculateAge();
		if (this.examen?.modoVista === "edit" || this.examen.modoVista === 'ver' || this.examen?.cargadoOffline) {
			this.setValuesOnFormOnVerOrEditMode();
		} else {
			this.examen.antecedentesLaboralesActividad = this.examForm.controls.antecedentesLaboralesActividad.value;
			this.examen.manipulacionCarga = this.examForm.controls.manipulacionCarga.value;
			this.examen.curFisEjeAnterposterior = this.examForm.controls.curFisEjeAnterposterior.value;
			this.examen.desEjeLateral = this.examForm.controls.desEjeLateral.value;
			this.examen.movDolorNormal = this.examForm.controls.movDolorNormal.value;
			this.examen.grado0 = this.examForm.controls.grado0.value;
			this.examen.grado1 = this.examForm.controls.grado1.value;
			this.examen.grado2 = this.examForm.controls.grado2.value;
			this.examen.grado3 = this.examForm.controls.grado3.value;
			this.examen.grado4 = this.examForm.controls.grado4.value;
			this.clickTableEvaluacionClinicaFinal('grado0', true);
			this.examen.patelarIzquierdaN = true; 
			this.examen.patelarDerechaN = true; 
			this.examen.aquilianorDerechaN = true; 
			this.examen.aquilianorIzquierdaN = true; 
			this.examForm.controls.patelarDerechaN.setValue(this.examen.patelarDerechaN);
			this.examForm.controls.patelarIzquierdaN.setValue(this.examen.patelarIzquierdaN);
			this.examForm.controls.aquilianorDerechaN.setValue(this.examen.aquilianorDerechaN);
			this.examForm.controls.aquilianorIzquierdaN.setValue(this.examen.aquilianorIzquierdaN);
			this.clickTableExploracionReflejos('patelarIzquierdaN',true);
			this.clickTableExploracionReflejos('patelarDerechaN',true);
			this.clickTableExploracionReflejos('aquilianorDerechaN',true);
			this.clickTableExploracionReflejos('aquilianorIzquierdaN',true);
			this.deshabilitarGrados();
		}
	}

	standarizeDate(date: any) {
		let splitedDate = date.replace(/\//g, '-');
		const dateParts = splitedDate.split('-');
		if (date.includes('/')) {
			return new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]));
		} else {
			return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
		}
	}

	/**
	   * @description:
	   * * Asignacion de valores a los campos en modo edicion
	   */
	private setValuesOnFormOnVerOrEditMode(): void {
		/**********************
		 *  * Campos del FOOTER
		 ***********************/
		this.examForm.controls.fechaRealizacion.setValue(this.examen.fechaRealizacion);
		this.examen.codigoDictamen = this.examen.tipoDictamen ? this.examen.tipoDictamen : this.examen.codigoDictamen;
		this.examForm.controls.codigoDictamen.setValue(this.examen.codigoDictamen);
		this.examForm.controls.medicoEspecialidad.setValue(this.examen.medicoEspecialidad);
		this.examForm.controls.medicoMatricula.setValue(this.examen.medicoMatricula);
		this.examForm.controls.medicoNombre.setValue(this.examen.medicoNombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ''));

		/**********************
		 *  * Campos del ESTUDIO
		 ***********************/
		this.examForm.controls.tareaHabitual.setValue(this.examen.tareaHabitual ? this.examen.tareaHabitual : '');
		this.examForm.controls.antecedentesLaboralesDescripcion.setValue(this.examen.antecedentesLaboralesDescripcion ? this.examen.antecedentesLaboralesDescripcion : '');
		this.examForm.controls.movDolorIrradiacionDescripcion.setValue(this.examen.movDolorIrradiacionDescripcion ? this.examen.movDolorIrradiacionDescripcion : '');
		this.examForm.controls.observaciones.setValue(this.examen.observaciones ? this.examen.observaciones : '');
		this.examForm.controls.antecedentesLaboralesActividad.setValue(this.examen.antecedentesLaboralesActividad);
		this.clickRadioButtonAntecedentesLaboralesActividad();
		this.examForm.controls.tiempoTareaDiaria.setValue(this.examen.tiempoTareaDiaria);
		this.examForm.controls.tiempoTareaSemanal.setValue(this.examen.tiempoTareaSemanal);
		this.examForm.controls.manipulacionCarga.setValue(
			this.examen.manipulacionCargaMenora10 ? 'manipulacionCargaMenora10' :
			this.examen.manipulacionCargaEntre10y20 ? 'manipulacionCargaEntre10y20' : 'manipulacionCargaMayora20'
		);
		this.examen.manipulacionCarga = this.examForm.controls.manipulacionCarga.value;
		this.clickRadioButtonManipulacionCarga();
		this.examForm.controls.palpacionNormal.setValue(this.examen.palpacionNormal);
		this.examen.movDolorIrradiacion ? this.clickCheckboxHabilitar(true, true, 'movDolorIrradiacionDescripcion') : null;
		this.validateCheckboxItems();
		this.examen.lasegueDerechoP = this.examen.lasegueDerecho === 'P';
		this.examen.lasegueDerechoN = this.examen.lasegueDerecho === 'N';
		this.examen.lasegueIzquierdoP = this.examen.lasegueIzquierdo === 'P';
		this.examen.lasegueIzquierdoN = this.examen.lasegueIzquierdo === 'N';
		this.examForm.controls.lasegueDerechoP.setValue(this.examen.lasegueDerechoP);
		this.examForm.controls.lasegueDerechoN.setValue(this.examen.lasegueDerechoN);
		this.examForm.controls.lasegueIzquierdoP.setValue(this.examen.lasegueIzquierdoP);
		this.examForm.controls.lasegueIzquierdoN.setValue(this.examen.lasegueIzquierdoN);
		this.clickTableExploracionNeurologica(this.examen.lasegueDerecho === 'P' ? 'lasegueDerechoP' : 'lasegueDerechoN', true);
		this.clickTableExploracionNeurologica(this.examen.lasegueIzquierdo === 'P' ? 'lasegueIzquierdoP' : 'lasegueIzquierdoN', true);
		this.examen.bragardDerechoP = this.examen.bragardDerecho === 'P';
		this.examen.bragardDerechoN = this.examen.bragardDerecho === 'N';
		this.examen.bragardIzquierdoP = this.examen.bragardIzquierdo === 'P';
		this.examen.bragardIzquierdoN = this.examen.bragardIzquierdo === 'N';
		this.examForm.controls.bragardDerechoP.setValue(this.examen.bragardDerechoP);
		this.examForm.controls.bragardDerechoN.setValue(this.examen.bragardDerechoN);
		this.examForm.controls.bragardIzquierdoP.setValue(this.examen.bragardIzquierdoP);
		this.examForm.controls.bragardIzquierdoN.setValue(this.examen.bragardIzquierdoN);
		this.clickTableExploracionNeurologica(this.examen.bragardDerecho === 'P' ? 'bragardDerechoP' : 'bragardDerechoN', true);
		this.clickTableExploracionNeurologica(this.examen.bragardIzquierdo === 'P' ? 'bragardIzquierdoP' : 'bragardIzquierdoN', true);
		this.examen.halluxDerechoP = this.examen.halluxDerecho === 'P';
		this.examen.halluxDerechoN = this.examen.halluxDerecho === 'N';
		this.examen.halluxIzquierdoP = this.examen.halluxIzquierdo === 'P';
		this.examen.halluxIzquierdoN = this.examen.halluxIzquierdo === 'N';
		this.examForm.controls.halluxDerechoP.setValue(this.examen.halluxDerechoP);
		this.examForm.controls.halluxDerechoN.setValue(this.examen.halluxDerechoN);
		this.examForm.controls.halluxIzquierdoP.setValue(this.examen.halluxIzquierdoP);
		this.examForm.controls.halluxIzquierdoN.setValue(this.examen.halluxIzquierdoN);
		this.clickTableExploracionNeurologica(this.examen.halluxDerecho === 'P' ? 'halluxDerechoP' : 'halluxDerechoN', true);
		this.clickTableExploracionNeurologica(this.examen.halluxIzquierdo === 'P' ? 'halluxIzquierdoP' : 'halluxIzquierdoN', true);
		this.examen.valsalvaP = this.examen.valsalva === 'P';
		this.examen.valsalvaN = this.examen.valsalva === 'N';
		this.examForm.controls.valsalvaP.setValue(this.examen.valsalvaP);
		this.examForm.controls.valsalvaN.setValue(this.examen.valsalvaN);
		this.clickTableExploracionNeurologica(this.examen.valsalva === 'P' ? 'valsalvaP' : 'valsalvaN', true);
		this.examen.patelarDerechaH = this.examen.patelarDerecha === 'H';
		this.examen.patelarDerechaA = this.examen.patelarDerecha === 'A';
		this.examen.patelarDerechaN = this.examen.patelarDerecha === 'N';
		this.examen.patelarIzquierdaH = this.examen.patelarIzquierda === 'H';
		this.examen.patelarIzquierdaA = this.examen.patelarIzquierda === 'A';
		this.examen.patelarIzquierdaN = this.examen.patelarIzquierda === 'N';
		this.examForm.controls.patelarDerechaH.setValue(this.examen.patelarDerechaH);
		this.examForm.controls.patelarDerechaA.setValue(this.examen.patelarDerechaA);
		this.examForm.controls.patelarDerechaN.setValue(this.examen.patelarDerechaN);
		this.examForm.controls.patelarIzquierdaH.setValue(this.examen.patelarIzquierdaH);
		this.examForm.controls.patelarIzquierdaA.setValue(this.examen.patelarIzquierdaA);
		this.examForm.controls.patelarIzquierdaN.setValue(this.examen.patelarIzquierdaN);
		this.clickTableExploracionReflejos(this.examen.patelarDerecha === 'H' ? 'patelarDerechaH' : this.examen.patelarDerecha === 'A' ? 'patelarDerechaA' : 'patelarDerechaN' , true);
		this.clickTableExploracionReflejos(this.examen.patelarIzquierda === 'H' ? 'patelarIzquierdaH' : this.examen.patelarIzquierda === 'A'? 'patelarIzquierdaA' : 'patelarIzquierdaN', true);
		this.examen.aquilianorDerechaH = this.examen.aquilianorDerecha === 'H';
		this.examen.aquilianorDerechaA = this.examen.aquilianorDerecha === 'A';
		this.examen.aquilianorDerechaN = this.examen.aquilianorDerecha === 'N';
		this.examen.aquilianorIzquierdaH = this.examen.aquilianorIzquierda === 'H';
		this.examen.aquilianorIzquierdaA = this.examen.aquilianorIzquierda === 'A';
		this.examen.aquilianorIzquierdaN = this.examen.aquilianorIzquierda === 'N';
		this.examForm.controls.aquilianorDerechaH.setValue(this.examen.aquilianorDerechaH);
		this.examForm.controls.aquilianorDerechaA.setValue(this.examen.aquilianorDerechaA);
		this.examForm.controls.aquilianorDerechaN.setValue(this.examen.aquilianorDerechaN);
		this.examForm.controls.aquilianorIzquierdaH.setValue(this.examen.aquilianorIzquierdaH);
		this.examForm.controls.aquilianorIzquierdaA.setValue(this.examen.aquilianorIzquierdaA);
		this.examForm.controls.aquilianorIzquierdaN.setValue(this.examen.aquilianorIzquierdaN);
		this.clickTableExploracionReflejos(this.examen.aquilianorDerecha === 'H' ? 'aquilianorDerechaH' : this.examen.aquilianorDerecha === 'A' ? 'aquilianorDerechaA' : 'aquilianorDerechaN', true);
		this.clickTableExploracionReflejos(this.examen.aquilianorIzquierda === 'H' ? 'aquilianorIzquierdaH' : this.examen.aquilianorIzquierda === 'A' ? 'aquilianorIzquierdaA' : 'aquilianorIzquierdaN', true);
		this.examForm.controls.grado0.setValue(this.examen.grado0);
		this.examForm.controls.grado1.setValue(this.examen.grado1);
		this.examForm.controls.grado2.setValue(this.examen.grado2);
		this.examForm.controls.grado3.setValue(this.examen.grado3);
		this.examForm.controls.grado4.setValue(this.examen.grado4);
		this.validateTableExploracionNeurologica();
		this.validateTableExploracionReflejos();
		this.validateTableEvaluacionClinicaFinal();
	}



	async onSubmit(): Promise<any> {
		this.submitted = true;
		if (this.examForm.invalid || this.invalidField || this.attachedFiles.invalid || this.tableExploracionNeurologicaInvalid ||
			 this.tableExploracionReflejosInvalid || this.tableEvaluacionClinicaFinalInvalid || this.medicoFirmaB64 == null) {
			this.navigateInvalidField('ng-invalid');
			return;
		}
		this.enviandose = true;
		if (this.isOnline) {
			this.saveToOnline();
		} else {
			this.saveToOffline();
		}
	}

	buildUrlApi(method: string): string {
		return `${environment.apiUrl}` + method;
	}

	buildRequest() {
		let examFormData = { ...this.examForm.getRawValue() };
		examFormData.userId = this.currentUser.userId;
		examFormData.username = this.currentUser.username;
		examFormData.modelId = this.currentUser.modelId;
		examFormData.tipoEstudio = this.configForm.code;
		examFormData.examenNumero = this.examen.id;
		examFormData.fechaRealizacion = moment(examFormData.fechaRealizacion).format('yyyy-MM-DD');
		examFormData.fechaIngresoEmpresa = moment(examFormData.fechaIngresoEmpresa).format('yyyy-MM-DD');
		examFormData.antiguedadPuestoTrabajador = moment(examFormData.antiguedadPuestoTrabajador).format('yyyy-MM-DD');
		this.examen?.modoVista === "edit" ? examFormData.esEdicion = !!(this.examen?.modoVista === "edit" && this.isOnline) : null;
		examFormData.adjuntos = this.attachedFiles.data;
		examFormData.medicoFirmaB64 = this.medicoFirmaB64;
		examFormData.medicoFirmaSigString = this.medicoFirmaSigString;

		examFormData.movDolorNormal = examFormData.movDolorNormal ? examFormData.movDolorNormal : false;
		examFormData.movDolorFlexion = examFormData.movDolorFlexion ? examFormData.movDolorFlexion : false;
		examFormData.movDolorExtension = examFormData.movDolorExtension ? examFormData.movDolorExtension : false;
		examFormData.movDolorLateralizacionIzq = examFormData.movDolorLateralizacionIzq ? examFormData.movDolorLateralizacionIzq : false;
		examFormData.movDolorLateralizacionDer = examFormData.movDolorLateralizacionDer ? examFormData.movDolorLateralizacionDer : false;
		examFormData.movDolorRotacionIzq = examFormData.movDolorRotacionIzq ? examFormData.movDolorRotacionIzq : false;
		examFormData.movDolorRotacionDer = examFormData.movDolorRotacionDer ? examFormData.movDolorRotacionDer : false;
		examFormData.movDolorIrradiacion = examFormData.movDolorIrradiacion ? examFormData.movDolorIrradiacion : false;

		examFormData = this.evaluateChangeTrabajador(examFormData);

		return examFormData;
	}

	private evaluateChangeTrabajador(object) {
		if (this.examen.seModificoTrabajador 
			|| this.examen.trabajador.fechaNacimiento != moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			|| this.examen.trabajador.apellidoNombre != this.examForm.controls.apellidoNombre.value) {

			object.trabajador = {
				apellidoNombre: this.examForm.controls.apellidoNombre.value,
				fechaNacimiento: moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			};
			this.examen.seModificoTrabajador = true;
		}
		return object;
	}

	private calculateAge(): void {
		let edad = null;
		if (this.examForm.controls.fechaNacimiento.value) {
			edad = moment().diff(
			  moment(this.examForm.controls.fechaNacimiento.value),
			  'years'
			);
		}
		this.examen.trabajador.edad = edad;
	}

	restrictDateIngresoEmpresa(): void {
		if(this.examForm.controls.antiguedadPuestoTrabajador.value != null && this.examForm.controls.antiguedadPuestoTrabajador.value != "") {
		  this.maxDateIngreso = this.examForm.controls.antiguedadPuestoTrabajador.value;
		} else {
		  this.maxDateIngreso = this.maxDate;
		}
	}

	private saveToOnline(): void {
		this.groupGTemplateService
			.loadFormularioC(this.buildRequest(), this.configForm.baseUrl)
			.subscribe(
				(response) => {
					this.databaseService.deleteItemFromTable(this.examen.id,
						`examenes${(this.examen.categoriaExamen === 'periodicos'
							? 'Periodicos'
							: 'Reevaluacion')}`);
					this.databaseService.deleteItemFromTable(this.examen.id,
						`examenes${(this.examen.categoriaExamen === 'periodicos'
							? 'PeriodicosFiltrados'
							: 'ReevaluacionFiltrados')}`);
					this.openSuccessAlert(response.message, 'examen');
				},
				(error) => {
					this.formatResponseAndOpenError(error);
				}
			);
	}

	private saveToOffline(): void {
		const dataToSend = this.buildRequest();
		dataToSend.fechaCarga = moment().format('yyyy-MM-DD');
		dataToSend.cargadoOffline = true;
		const details = (this.examen?.modoVista === "edit") ? 'Los cambios en el examen fueron guardados correctamente' : 'El examen se guardó correctamente en Por enviar';

		this.databaseService
			.setExameneOnExamenesPorEnviarTable(
				this.examen,
				dataToSend,
				false,
				this.examen.categoriaExamen === 'periodicos'
					? 'Periodicos'
					: 'Reevaluacion',
				this.buildUrlApi(this.configForm.baseUrl)
			)
			.then((response) => {
				this.databaseService.deleteItemFromTable(this.examen.id,
					`examenes${(this.examen.categoriaExamen === 'periodicos'
						? 'Periodicos'
						: 'Reevaluacion')}`);
				this.databaseService.deleteItemFromTable(this.examen.id,
					`examenes${(this.examen.categoriaExamen === 'periodicos'
						? 'PeriodicosFiltrados'
						: 'ReevaluacionFiltrados')}`);
				this.backgroundSyncService.registerEvent('save-examen');
				this.openSuccessAlert(
					details,
					'examen'
				);
			})
			.catch((e) => {
				this.messageAlertServices.setMessage(0, {
					severity: 'error',
					summary: '',
					detail:
						'Ha ocurrido un error. Por favor reinitent más tarde y disculpe las molestias ocasionadas',
					key: 'examen',
				});
			});
	}

	formatResponseAndOpenError(error) {
		let message = error.error.message + ' ';
		message = message + error.error.errors.map((x) => {
			return x;
		}).join(' ');
		this.openErrorAlert(message, 'examen');
	}

	private openErrorAlert(message: string, key: string): void {
		this.messageAlertServices.setMessage(0, {
			severity: 'error',
			summary: '',
			detail: message,
			key: key,
		});
		setTimeout(() => {
			const header = document.querySelector('#templateContainer') as any;
			window.scroll(0, header.offsetTop - 150);
		}, 100);
		this.enviandose = false;
	}

	private openSuccessAlert(message: string, key: string): void {
		this.messageAlertServices.setMessage(0, {
			severity: 'success',
			summary: '',
			detail: message,
			key: key,
		});
		setTimeout(() => {
			this.returnToExams();
		}, 500);
		this.enviandose = false;
	}

	private navigateInvalidField(classFocus: string): void {
		const invalidFields = [].slice.call(
			document.getElementsByClassName(classFocus)
		);
		const field = invalidFields[1];
		field.scrollIntoViewIfNeeded();
		field.focus();
	}

	private clickRadioButtonAntecedentesLaboralesActividad(): void {
		if (this.examForm.controls.antecedentesLaboralesActividad.value) {
			this.examForm.controls.antecedentesLaboralesDescripcion.enable();
			this.examForm.controls.antecedentesLaboralesDescripcion.setValidators([Validators.required, Validators.maxLength(1000)]);
		} else {
			this.examForm.controls.antecedentesLaboralesDescripcion.setValue('');
			this.examForm.controls.antecedentesLaboralesDescripcion.disable();
			this.examForm.controls.antecedentesLaboralesDescripcion.setValidators(null);
		}
		this.examForm.controls.antecedentesLaboralesDescripcion.updateValueAndValidity();
	}

	private clickRadioButtonManipulacionCarga(): void {
		this.examForm.controls.manipulacionCargaMenora10.setValue(this.examForm.controls.manipulacionCarga.value === 'manipulacionCargaMenora10');
		this.examForm.controls.manipulacionCargaEntre10y20.setValue(this.examForm.controls.manipulacionCarga.value === 'manipulacionCargaEntre10y20');
		this.examForm.controls.manipulacionCargaMayora20.setValue(this.examForm.controls.manipulacionCarga.value === 'manipulacionCargaMayora20');
		this.examForm.controls.manipulacionCargaMenora10.updateValueAndValidity();
		this.examForm.controls.manipulacionCargaEntre10y20.updateValueAndValidity();
		this.examForm.controls.manipulacionCargaMayora20.updateValueAndValidity();
		this.examForm.controls.manipulacionCarga.updateValueAndValidity();
	}

	clickCheckBoxPalpacion(valor): void {
		switch (valor) {
			case 'NORMAL':
				this.examForm.controls.palpacionApofosisEspinosa.setValue(false);
				this.examForm.controls.palpacionContracturaMuscular.setValue(false);
				break;
			default:
				this.examForm.controls.palpacionNormal.setValue(false);
				break;
		}
		this.validateCheckboxItems();
	}

	clickCheckBoxMovilidadDolor(valor, event) {
		switch (valor) {
			case 'movDolorNormal':
				this.examForm.controls.movDolorFlexion.setValue(false);
				this.examForm.controls.movDolorExtension.setValue(false);
				this.examForm.controls.movDolorLateralizacionIzq.setValue(false);
				this.examForm.controls.movDolorLateralizacionDer.setValue(false);
				this.examForm.controls.movDolorRotacionIzq.setValue(false);
				this.examForm.controls.movDolorRotacionDer.setValue(false);
				this.examForm.controls.movDolorIrradiacion.setValue(false);
				this.clickCheckboxHabilitar(event.checked, false, 'movDolorIrradiacionDescripcion');
				this.validateCheckboxItems();
				break;
			case 'movDolorFlexion':
				this.examForm.controls.movDolorNormal.setValue(false);
				this.validateCheckboxItems();
				break;
			case 'movDolorExtension':
				this.examForm.controls.movDolorNormal.setValue(false);
				this.validateCheckboxItems();
				break;
			case 'movDolorLateralizacionIzq':
				this.examForm.controls.movDolorNormal.setValue(false);
				this.validateCheckboxItems();
				break;
			case 'movDolorLateralizacionDer':
				this.examForm.controls.movDolorNormal.setValue(false);
				this.validateCheckboxItems();
				break;
			case 'movDolorRotacionIzq':
				this.examForm.controls.movDolorNormal.setValue(false);
				this.validateCheckboxItems();
				break;
			case 'movDolorRotacionDer':
				this.examForm.controls.movDolorNormal.setValue(false);
				this.validateCheckboxItems();
				break;
			case 'movDolorIrradiacion':
				this.examForm.controls.movDolorNormal.setValue(false);
				this.clickCheckboxHabilitar(event.checked, event.checked, 'movDolorIrradiacionDescripcion');
				break;
		}
	}

	clickCheckboxHabilitar(checked, value, field): void {
		this.validateCheckboxItems();
		if (!value || !checked) {
			this.examForm.controls[field].disable();
			this.examForm.controls[field].setValue('');
			this.examForm.controls[field].setValidators(null);
		} else {
			this.examForm.controls[field].enable();
			this.examForm.controls[field].setValidators([
				Validators.required,
				Validators.maxLength(1000),
			]);
		}
		this.examForm.controls[field].updateValueAndValidity();
	}

	validateCheckboxItems(): void {
		if ((!this.examForm.controls.movDolorNormal.value
			&& !this.examForm.controls.movDolorFlexion.value
			&& !this.examForm.controls.movDolorExtension.value
			&& !this.examForm.controls.movDolorLateralizacionIzq.value
			&& !this.examForm.controls.movDolorLateralizacionDer.value
			&& !this.examForm.controls.movDolorRotacionIzq.value
			&& !this.examForm.controls.movDolorRotacionDer.value
			&& !this.examForm.controls.movDolorIrradiacion.value) || (!this.examForm.controls.palpacionNormal 
			&& !this.examForm.controls.palpacionApofosisEspinosa && !this.examForm.controls.palpacionContracturaMuscular)) {
			this.invalidField = true;
		} else {
			this.invalidField = false;
		}
	}

	clickTableExploracionNeurologica(valor, checked) {
		if (checked) {
			switch (valor) {
				case 'lasegueDerechoP':
					this.examForm.controls.lasegueDerechoN.setValue(false);
					this.examForm.controls.lasegueDerecho.setValue('P');
					break;
				case 'lasegueDerechoN':
					this.examForm.controls.lasegueDerechoP.setValue(false);
					this.examForm.controls.lasegueDerecho.setValue('N');
					break;
				case 'lasegueIzquierdoP':
					this.examForm.controls.lasegueIzquierdoN.setValue(false);
					this.examForm.controls.lasegueIzquierdo.setValue('P');
					break;
				case 'lasegueIzquierdoN':
					this.examForm.controls.lasegueIzquierdoP.setValue(false);
					this.examForm.controls.lasegueIzquierdo.setValue('N');
					break;
				case 'bragardDerechoP':
					this.examForm.controls.bragardDerechoN.setValue(false);
					this.examForm.controls.bragardDerecho.setValue('P');
					break;
				case 'bragardDerechoN':
					this.examForm.controls.bragardDerechoP.setValue(false);
					this.examForm.controls.bragardDerecho.setValue('N');
					break;
				case 'bragardIzquierdoP':
					this.examForm.controls.bragardIzquierdoN.setValue(false);
					this.examForm.controls.bragardIzquierdo.setValue('P');
					break;
				case 'bragardIzquierdoN':
					this.examForm.controls.bragardIzquierdoP.setValue(false);
					this.examForm.controls.bragardIzquierdo.setValue('N');
					break;
				case 'halluxDerechoP':
					this.examForm.controls.halluxDerechoN.setValue(false);
					this.examForm.controls.halluxDerecho.setValue('P');
					break;
				case 'halluxDerechoN':
					this.examForm.controls.halluxDerechoP.setValue(false);
					this.examForm.controls.halluxDerecho.setValue('N');
					break;
				case 'halluxIzquierdoP':
					this.examForm.controls.halluxIzquierdoN.setValue(false);
					this.examForm.controls.halluxIzquierdo.setValue('P');
					break;
				case 'halluxIzquierdoN':
					this.examForm.controls.halluxIzquierdoP.setValue(false);
					this.examForm.controls.halluxIzquierdo.setValue('N');
					break;
				case 'valsalvaP':
					this.examForm.controls.valsalvaN.setValue(false);
					this.examForm.controls.valsalva.setValue('P');
					break;
				case 'valsalvaN':
					this.examForm.controls.valsalvaP.setValue(false);
					this.examForm.controls.valsalva.setValue('N');
					break;
			}
		}
		this.validateTableExploracionNeurologica();
	}

	validateTableExploracionNeurologica() {
		if (
			(!this.examForm.controls.lasegueDerechoP.value && !this.examForm.controls.lasegueDerechoN.value) ||
			(!this.examForm.controls.lasegueIzquierdoP.value && !this.examForm.controls.lasegueIzquierdoN.value) ||
			(!this.examForm.controls.bragardDerechoP.value && !this.examForm.controls.bragardDerechoN.value) ||
			(!this.examForm.controls.bragardIzquierdoP.value && !this.examForm.controls.bragardIzquierdoN.value) ||
			(!this.examForm.controls.halluxDerechoP.value && !this.examForm.controls.halluxDerechoN.value) ||
			(!this.examForm.controls.halluxIzquierdoP.value && !this.examForm.controls.halluxIzquierdoN.value) ||
			(!this.examForm.controls.valsalvaP.value && !this.examForm.controls.valsalvaN.value)
			) {
			this.tableExploracionNeurologicaInvalid = true;
		} else {
			this.tableExploracionNeurologicaInvalid = false;
		}
	}

	clickTableExploracionReflejos(valor, checked) {
		if (checked) {
			switch (valor) {
				case 'patelarDerechaH':
					this.examForm.controls.patelarDerechaA.setValue(false);
					this.examForm.controls.patelarDerechaN.setValue(false);
					this.examForm.controls.patelarDerecha.setValue('H');
					break;
				case 'patelarDerechaA':
					this.examForm.controls.patelarDerechaH.setValue(false);
					this.examForm.controls.patelarDerechaN.setValue(false);
					this.examForm.controls.patelarDerecha.setValue('A');
					break;
				case 'patelarDerechaN':
					this.examForm.controls.patelarDerechaH.setValue(false);
					this.examForm.controls.patelarDerechaA.setValue(false);
					this.examForm.controls.patelarDerecha.setValue('N');
					break;
				case 'patelarIzquierdaH':
					this.examForm.controls.patelarIzquierdaA.setValue(false);
					this.examForm.controls.patelarIzquierdaN.setValue(false);
					this.examForm.controls.patelarIzquierda.setValue('H');
					break;
				case 'patelarIzquierdaA':
					this.examForm.controls.patelarIzquierdaH.setValue(false);
					this.examForm.controls.patelarIzquierdaN.setValue(false);
					this.examForm.controls.patelarIzquierda.setValue('A');
					break;
				case 'patelarIzquierdaN':
					this.examForm.controls.patelarIzquierdaH.setValue(false);
					this.examForm.controls.patelarIzquierdaA.setValue(false);
					this.examForm.controls.patelarIzquierda.setValue('N');
					break;
				case 'aquilianorDerechaH':
					this.examForm.controls.aquilianorDerechaA.setValue(false);
					this.examForm.controls.aquilianorDerechaN.setValue(false);
					this.examForm.controls.aquilianorDerecha.setValue('H');
					break;
				case 'aquilianorDerechaA':
					this.examForm.controls.aquilianorDerechaH.setValue(false);
					this.examForm.controls.aquilianorDerechaN.setValue(false);
					this.examForm.controls.aquilianorDerecha.setValue('A');
					break;
				case 'aquilianorDerechaN':
					this.examForm.controls.aquilianorDerechaH.setValue(false);
					this.examForm.controls.aquilianorDerechaA.setValue(false);
					this.examForm.controls.aquilianorDerecha.setValue('N');
					break;
				case 'aquilianorIzquierdaH':
					this.examForm.controls.aquilianorIzquierdaA.setValue(false);
					this.examForm.controls.aquilianorIzquierdaN.setValue(false);
					this.examForm.controls.aquilianorIzquierda.setValue('H');
					break;
				case 'aquilianorIzquierdaA':
					this.examForm.controls.aquilianorIzquierdaH.setValue(false);
					this.examForm.controls.aquilianorIzquierdaN.setValue(false);
					this.examForm.controls.aquilianorIzquierda.setValue('A');
					break;
				case 'aquilianorIzquierdaN':
					this.examForm.controls.aquilianorIzquierdaH.setValue(false);
					this.examForm.controls.aquilianorIzquierdaA.setValue(false);
					this.examForm.controls.aquilianorIzquierda.setValue('N');
					break;
			}
		}
		this.validateTableExploracionReflejos();
		this.deshabilitarGrados();
	}

	validateTableExploracionReflejos() {
		if (
			(!this.examForm.controls.patelarDerechaH.value && !this.examForm.controls.patelarDerechaA.value && !this.examForm.controls.patelarDerechaN.value) ||
			(!this.examForm.controls.patelarIzquierdaH.value && !this.examForm.controls.patelarIzquierdaA.value && !this.examForm.controls.patelarIzquierdaN.value) ||
			(!this.examForm.controls.aquilianorDerechaH.value && !this.examForm.controls.aquilianorDerechaA.value && !this.examForm.controls.aquilianorDerechaN.value) ||
			(!this.examForm.controls.aquilianorIzquierdaH.value && !this.examForm.controls.aquilianorIzquierdaA.value && !this.examForm.controls.aquilianorIzquierdaN.value)
			) {
			this.tableExploracionReflejosInvalid = true;
		} else {
			this.tableExploracionReflejosInvalid = false;
		}
	}

	clickTableEvaluacionClinicaFinal(valor, checked) {
		if (checked) {
			switch (valor) {
				case 'grado0':
					this.examForm.controls.grado1.setValue(false);
					this.examForm.controls.grado2.setValue(false);
					this.examForm.controls.grado3.setValue(false);
					this.examForm.controls.grado4.setValue(false);
					break;
				case 'grado1':
					this.examForm.controls.grado0.setValue(false);
					this.examForm.controls.grado2.setValue(false);
					this.examForm.controls.grado3.setValue(false);
					this.examForm.controls.grado4.setValue(false);
					break;
				case 'grado2':
					this.examForm.controls.grado0.setValue(false);
					this.examForm.controls.grado1.setValue(false);
					this.examForm.controls.grado3.setValue(false);
					this.examForm.controls.grado4.setValue(false);
					break;
				case 'grado3':
					this.examForm.controls.grado0.setValue(false);
					this.examForm.controls.grado1.setValue(false);
					this.examForm.controls.grado2.setValue(false);
					this.examForm.controls.grado4.setValue(false);
					break;
				case 'grado4':
					this.examForm.controls.grado0.setValue(false);
					this.examForm.controls.grado1.setValue(false);
					this.examForm.controls.grado2.setValue(false);
					this.examForm.controls.grado3.setValue(false);
					break;
			}
		}
		this.validateTableEvaluacionClinicaFinal();
	}

	validateTableEvaluacionClinicaFinal() {
		if (!this.examForm.controls.grado0.value && !this.examForm.controls.grado1.value && !this.examForm.controls.grado2.value && !this.examForm.controls.grado3.value && !this.examForm.controls.grado4.value) {
			this.tableEvaluacionClinicaFinalInvalid = true;
		} else {
			this.tableEvaluacionClinicaFinalInvalid = false;
		}
	}

	deshabilitarApellidoNombreTrabajador() {
		return this.examen.trabajador.apellidoNombre.replace(/[^a-zA-Z]/g, '').toLowerCase() !== 'alta' && this.examen.trabajador.apellidoNombre.trim().length !== 0;
	}

	deshabilitarGrados() {
		this.disabledGroup = false;
		if (this.examForm.controls.patelarDerechaN.value && this.examForm.controls.patelarIzquierdaN.value 
			&& this.examForm.controls.aquilianorDerechaN.value && this.examForm.controls.aquilianorIzquierdaN.value ) {
				this.examForm.controls.grado0.setValue(true);
				this.clickTableEvaluacionClinicaFinal('grado0', true);
				this.disabledGroup = true;
 		}
	}

}
